import 'babel-polyfill';
import React from 'react';
import ReactDOM from 'react-dom';

import { ConnectedRouter as Router } from 'react-router-redux';
import { history } from 'src/data/store';
import { ThemeProvider } from 'emotion-theming';
import theme from 'src/lib/theme';

import AppProvider from './ConnectedComponents/utils/AppProvider';
import App from './ConnectedComponents/App';

import registerServiceWorker from './registerServiceWorker';

const Root = () => (
	<ThemeProvider theme={theme}>
		<AppProvider>
			<Router history={history}>
				<App />
			</Router>
		</AppProvider>
	</ThemeProvider>
);

ReactDOM.render(<Root />, document.getElementById('root'));

registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js